export default __webpack_public_path__ + "static/media/milestone 4400.70656981.svg";